import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import './styles/globals.css';

declare global {
  interface Window {
    __QDF_API_URL__?: string;
    __QDF_ENV__?: string;
    __QDF_BRAND__?: string;
  }
}

/**
 * In production, load runtime config from /config.json (generated by CDK).
 * This provides the correct API URL per environment without needing
 * separate frontend builds for dev and prod.
 */
async function loadRuntimeConfig(): Promise<void> {
  if (import.meta.env.DEV) return; // Local dev uses Vite proxy

  try {
    const response = await fetch('/config.json');
    const config = await response.json();
    if (config.apiUrl) {
      window.__QDF_API_URL__ = config.apiUrl;
    }
    if (config.environment) {
      window.__QDF_ENV__ = config.environment;
    }
    if (config.brand) {
      window.__QDF_BRAND__ = config.brand;
    }
  } catch {
    console.warn('Failed to load runtime config — falling back to defaults');
  }
}

loadRuntimeConfig().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
